import dayjs from "dayjs";
import { Member } from "../entity/Member";

export interface MemberValidationObj {
  firstName: boolean;
  lastName: boolean;
  gender: boolean;
  birthDate: boolean;
  address: boolean;
  email: boolean;
  phone: boolean;
  nationalId: boolean;
  note: boolean;
};

export const memberValidationObjInit: MemberValidationObj = {
  firstName: true,
  lastName: true,
  gender: true,
  birthDate: true,
  address: true,
  email: true,
  phone: true,
  nationalId: true,
  note: true,
};

export const validateMember = (m: Member): MemberValidationObj => {
  return {
    firstName: m.firstName.length > 0,
    lastName: m.lastName.length > 0,
    gender: m.gender !== "",
    birthDate: dayjs(m.birthDate, "YYYY-MM-DD", true).isValid(),
    address: m.address.length > 0,
    email: m.email.length > 0,
    phone: m.phone.length > 0,
    nationalId: true,
    note: true,
  };
};
